import { render } from "./PersonalDetailEmail.vue?vue&type=template&id=31d3513b&scoped=true"
import script from "./PersonalDetailEmail.vue?vue&type=script&lang=js"
export * from "./PersonalDetailEmail.vue?vue&type=script&lang=js"

import "./PersonalDetailEmail.vue?vue&type=style&index=0&id=31d3513b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d3513b"]])

export default __exports__